import React, { Suspense } from "react";
import "react-datepicker/dist/react-datepicker.css";
// ** Router Import
import Router from "./router/Router";
import GlobalContainer from "./containers/globalContainer";
import * as Sentry from "@sentry/react";
import ErrorBoundaryFallback from "./common/ErrorBoundaryFallback/ErrorBoundaryFallback";
// import UpgradeNotification from "./upgradeNotification/upgradeNotification";
// import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const App = () => {
  return (
    <Suspense fallback={null}>
      {/* <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA}> */}
      <Sentry.ErrorBoundary
        beforeCapture={(scope) => {
          scope.setTag("App", "src/App.js");
        }}
        fallback={({ error, componentStack, resetError }) => (
          <ErrorBoundaryFallback
            error={error}
            componentStack={componentStack}
            resetError={resetError}
          />
        )}
      >
        {/* <UpgradeNotification /> */}
        <GlobalContainer>
          <Router />
        </GlobalContainer>
      </Sentry.ErrorBoundary>
      {/* </GoogleReCaptchaProvider> */}
    </Suspense>
  );
};

export default App;
